jQuery(document).ready(function($){

    if ($('#modal-form').length) {
        $('body').on('wpcf7mailsent', function() {
            $('#modal-form').foundation('open');
        });
    }

    if ($('input[name="gaID"]').length) {
        var want_events = ['wpcf7invalid', 'wpcf7spam', 'wpcf7mailfailed', 'wpcf7mailsent', 'wpcf7submit',];

        $('body').on(want_events.join(' '), function(event) {
            window.dataLayer.push({
                "event": event.type,
                "formId": event.detail.contactFormId,
                "containerPostId" : event.detail.containerPostId,
                "gaID": $('#' + event.detail.unitTag + ' input[name="gaID"]').val(),
            });
        });
    }

});
